export default {
  basic: () => import("/home/runner/_work/jbg-web/jbg-web/src/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/home/runner/_work/jbg-web/jbg-web/src/layouts/default.vue").then(m => m.default || m),
  docs: () => import("/home/runner/_work/jbg-web/jbg-web/src/layouts/docs.vue").then(m => m.default || m)
}